import { render } from "./BaseMessages.vue?vue&type=template&id=10338a46&scoped=true"
import script from "./BaseMessages.vue?vue&type=script&lang=js"
export * from "./BaseMessages.vue?vue&type=script&lang=js"

import "./BaseMessages.vue?vue&type=style&index=0&id=10338a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10338a46"]])

export default __exports__